"use client";

import SearchIcon from "@/assets/images/icon-search.svg";

/** Visual-only search box. No state, no shortcuts, no dropdown — backend not ready. */
export function TopNavSearch() {
  return (
    <div className="relative w-full max-w-md">
      <span className="pointer-events-none absolute left-3 top-1/2 -translate-y-1/2">
        <SearchIcon className="size-4 text-neutral-400" />
      </span>
      <input
        type="text"
        placeholder="Search bookings, customers…"
        disabled
        aria-label="Search (coming soon)"
        className="paragraph-sm w-full rounded-md border border-stroke-soft-200 bg-white py-2 pl-9 pr-3 text-neutral-700 placeholder:text-neutral-400 focus:outline-none disabled:cursor-not-allowed"
      />
    </div>
  );
}
